import React, { useState } from "react";
import { useBotStore } from "../../stores/botStore";
import { Dropdown, AddModal } from "components";

const TYPE_OPTIONS = [
  { value: "clean", label: "Видалення зі статистики" },
  { value: "change", label: "Зміна менеджера" },
];

// Компонент модального вікна для створення нового запиту
const AddRequestModal = ({ isOpen, onClose, managerOptions }) => {
  // Отримуємо дані і дії зі стору
  const createQueueRequest = useBotStore((state) => state.createQueueRequest);
  const isLoading = useBotStore((state) => state.isLoading);

  // Стан полів форми
  const [requestType, setRequestType] = useState("clean");
  const [orderId, setOrderId] = useState("");
  const [managerId, setManagerId] = useState(null);
  const [newManagerId, setNewManagerId] = useState(null);

  // Очищення форми перед закриттям вікна
  const handleClose = () => {
    setRequestType("clean");
    setOrderId("");
    setManagerId(null);
    setNewManagerId(null);
    onClose();
  };

  // Обробка відправки форми
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (!orderId || !managerId) return;

    // Формуємо базовий об'єкт опису
    const description = {
      order_id: parseInt(orderId, 10),
      manager_id: parseInt(managerId, 10),
    };

    // Додаємо ID нового менеджера лише для операції заміни
    if (requestType === "change" && newManagerId) {
      description.new_manager_id = parseInt(newManagerId, 10);
    }

    const success = await createQueueRequest({ type: requestType, description });

    // Закриваємо модалку, якщо запит успішний
    if (success) handleClose();
  };

  return (
    <AddModal isOpen={isOpen} onClose={handleClose} title="Новий запит">
      <form onSubmit={handleAddSubmit}>
        <div className="add-modal-body">
          <div className="form-group">
            <label>Тип операції</label>
            <Dropdown
              inputId="type-dropdown"
              options={TYPE_OPTIONS}
              selected={requestType}
              onChange={setRequestType}
              placeholder="Оберіть тип"
            />
          </div>

          <div className="form-group">
            <label>ID замовлення *</label>
            <input
              type="number"
              placeholder="Введіть ID замовлення"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Менеджер *</label>
            <Dropdown
              inputId="manager-dropdown"
              options={managerOptions}
              selected={managerId}
              onChange={setManagerId}
              mode="autocomplete"
              placeholder="Оберіть менеджера"
            />
          </div>

          {/* Показуємо поле для нового менеджера тільки при відповідному типі операції */}
          {requestType === "change" && (
            <div className="form-group">
              <label>Новий менеджер *</label>
              <Dropdown
                inputId="new-manager-dropdown"
                options={managerOptions}
                selected={newManagerId}
                onChange={setNewManagerId}
                placeholder="Оберіть нового менеджера"
              />
            </div>
          )}
        </div>

        <div className="add-modal-footer">
          <button type="button" className="btn-cancel" onClick={handleClose}>
            Скасувати
          </button>
          <button type="submit" className="btn-save" disabled={isLoading}>
            Створити
          </button>
        </div>
      </form>
    </AddModal>
  );
};

export default AddRequestModal;
